import React, { ReactNode } from 'react'
import { StyledCard } from './style'

interface InfoCardProps {
  children?: ReactNode
}

const InfoCard: React.FC<InfoCardProps> = ({ children }) => {
  return (
    <StyledCard>
      {children}
    </StyledCard>
  )
}

export default InfoCard